import classNames from 'classnames/bind';

// @styles
import css from './RadioGroup.module.scss';

// @types
import {TRadioGroup} from './RadioGroup';

const cx = classNames.bind(css);

export const getCssClasses = ({
                                  size,
                                  accent,
                                  wrapperClassName,
                                  titleClassName,
                                  listItemClassName,
                                  labelClassName,
                                  captionClassName,
                                  errorClassName,
                                  disabled,
                              }: Partial<TRadioGroup>) => {
    const _wrapperClassName = cx('wrapper', {[wrapperClassName!]: !!wrapperClassName});
    const _titleClassName = cx('title', {[titleClassName!]: !!titleClassName});
    const _listItemClassName = cx('list_item', {[listItemClassName!]: !!listItemClassName});
    const _labelClassName = cx('label', {[labelClassName!]: !!labelClassName});
    const _radioButtonClassName = cx('radio_button', {
        radio_button__disabled: !!disabled,
        [`radio_button_size_${size}`]: !!size,
        [`radio_button_accent_${accent}`]: !!accent,
    });
    const _captionClassName = cx('caption', {caption__disabled: !!disabled, [captionClassName!]: !!captionClassName});
    const _errorClassName = cx('error', {[errorClassName!]: !!errorClassName});

    return {
        _wrapperClassName,
        _titleClassName,
        _listItemClassName,
        _labelClassName,
        _radioButtonClassName,
        _captionClassName,
        _errorClassName,
    };
};
